import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import Footer from "../components/Footer";
import Swal from "sweetalert2";

function UserHistory() {
  const [uid, setUid] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const auth = getAuth();
  const apiKey = process.env.REACT_APP_API_KEY;
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);
        setUserEmail(user.email);
      } else {
        setUid(null);
      }
    });
    return () => unsubscribe();
  }, []);

  console.log(localStorage.getItem("isAdmin") == "true");

  useEffect(() => {
    const fetchHistory = async () => {
      const shouldUseEmail =
        localStorage.getItem("isAdmin") == "true" && searchEmail.trim() !== "";

      if (!uid && !shouldUseEmail) return;

      setLoading(true);
      setNotFound(false);

      try {
        const url = shouldUseEmail
          ? `https://api.v1.spotyourleads.com/user/purchaseHistory/${searchEmail}`
          : `https://api.v1.spotyourleads.com/user/purchaseHistory/${uid}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        });

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();

        const leads = data?.leads || [];
        setHistory(leads);
        setNotFound(shouldUseEmail && leads.length === 0);
      } catch (error) {
        console.error("Failed to fetch purchase history:", error);
        setHistory([]);
        setNotFound(shouldUseEmail);
      }

      setLoading(false);
    };

    fetchHistory();
  }, [uid, searchEmail]);
  const handleRefund = async (leadId, userId) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to refund this lead.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, refund it!",
    });
  
    if (confirmed.isConfirmed) {
      const status = "refund";
      const url = `https://api.v1.spotyourleads.com/lead/purchaseStatus/${status}?leadid=${leadId}&userId=${userId}`;
  
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey, 
          },
        });
  
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
        const data = await response.json();
  
        Swal.fire({
          title: "Refund Successful!",
          text: data.message || "Lead has been refunded.",
          icon: "success",
        });
      } catch (error) {
        console.error("Refund failed:", error);
        Swal.fire({
          title: "Error!",
          text: "Refund failed. Please try again.",
          icon: "error",
        });
      }
    }
  };
  
  
  return (
    <>
      <section className="auto-leads">
        <div className="about">
          <Container>
            <div className="pricing-title">
              <h2>Purchase History</h2>
            </div>
            {localStorage.getItem("isAdmin") == "true" && uid && (
              <Form.Group className="mb-3" controlId="searchEmail">
                <Form.Label>Search by User Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter user's email"
                  value={searchEmail}
                  onChange={(e) => setSearchEmail(e.target.value)}
                />
              </Form.Group>
            )}
          </Container>
        </div>

        <Container>
          <div className="max-w-md mx-auto p-4 space-y-8">
            {loading ? (
              <p>Loading...</p>
            ) : notFound ? (
              <p>No history found for this email.</p>
            ) : history.length === 0 ? (
              <p>No purchase history found.</p>
            ) : (
              <div className="table-container">
                <table className="history-table table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Owner</th>
                      <th>Phone</th>
                      <th>Address</th>
                      <th>City</th>
                      <th>State</th>
                      <th>-</th>

                      <th>Status</th>

                      <th>Buyer ID</th>
                      <th>purchased At </th>
                      <th>Accepted At</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Property Type</th>
                      <th>Listed</th>
                      <th>Occupied</th>
                      <th>Owned Years</th>
                      <th>Mortgage</th>
                      <th>Repairs</th>
                      <th>Reason</th>
                      <th>Closing Time</th>
                      <th>Price</th>
                      <th>Base Price</th>
                      <th>Discount %</th>
                      <th>Is Free</th>
                      <th>Source</th>
                    </tr>
                  </thead>

                  <tbody>
                    {history.map((lead, index) => (
                      <tr key={index}>
                        <td>
                          {lead.ownerFirstName} {lead.ownerLastName}
                        </td>
                        <td>{lead.phoneNumber}</td>
                        <td>{lead.propertyAddress}</td>
                        <td>{lead.city}</td>
                        <td>{lead.state}</td>
                        <td>
  <button
  disabled={lead.purchasedStatus !== "pending"}
    className="btn btn-danger btn-sm"
    onClick={() => handleRefund(lead.id, lead.buyerId)}
  >
    Refund
  </button>
</td>
                        <td>{lead.purchasedStatus}</td>


                        <td>{lead.buyerId}</td>
                        <td>
                          {new Date(lead.purchasedAt * 1000).toLocaleString()}
                        </td>

                        <td>
                          {new Date(lead.acceptedAt * 1000).toLocaleString()}
                        </td>
                        <td>
                          {new Date(lead.createdAt * 1000).toLocaleString()}
                        </td>
                        <td>
                          {new Date(lead.updatedAt * 1000).toLocaleString()}
                        </td>
                        <td>{lead.propertyType}</td>
                        <td>{lead.propertyListed}</td>
                        <td>{lead.livingStatus}</td>
                        <td>{lead.ownedYears}</td>
                        <td>{lead.hasMortgage}</td>
                        <td>{lead.repairsNeeded?.join(", ")}</td>
                        <td>{lead.sellingReason?.join(", ")}</td>
                        <td>{lead.closingTime}</td>
                        <td>${lead.price}</td>
                        <td>${lead.basePrice}</td>
                        <td>{lead.discountPercentage}%</td>
                        <td>{lead.isFree ? "Yes" : "No"}</td>
                        <td>{lead.source}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Container>
      </section>
      <Footer />
    </>
  );
}

export default UserHistory;
